export default __webpack_public_path__ + "Revenue_Calculator_New_Product_Template_NA-it-IT.00050708.xlsx";